import React, { Component } from "react";
import { connect } from "react-redux";
import cx from 'classnames';
import { Link } from "react-router-dom";

import { userStyles } from "../styles";
import {
  Typography,
  Grid,
  Button,
  WithStyles,
  withStyles,
  TableHead,
  Paper,
  Chip,
  FormGroup
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { MyPATDialog } from "../../common";
import MyPATNoDataPanel from "../../common/MyPATNoDataPanel";
import { withRouter } from 'react-router-dom';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { MyPATSearchBar } from "../../common";
import { 
  searchUserMgmt,
  getRolesList,
  setPaginationToFirstPage,
  removeRoleChip
} from "../actions/userActions";
import { MODULES } from "../../../constants/comman";
interface RolesTableProps extends WithStyles<typeof userStyles> {
  currentPage: any;
  history: any;
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  defaultRolesData: any,
  isSuperAdmin: boolean,
  searchUserMgmt: Function,
  userDetails: any,
  rolesChips: any,
  rolesSearchData: any,
  getRolesList: Function,
  setPaginationToFirstPage: Function,
  removeRoleChip: Function
}
interface RolesTableState {
  currentPage: number;
  headers: any;
  data: any;
  action: any;
  open: any;
  selectedId: any;
  selectedRecord: any;
  userDetails: any;
  isSuperAdmin: any;
}

interface RolesSearchObject {
	clients: string[],
	roles: string[]
}

interface UsersSearchObject {
	status: string,
	userDetails: string[],
	clients: string[],
	roles: string[]
}

interface SearchDataObject {
	searchText: string,
	rolesSearch?: RolesSearchObject,
	usersSearch?: UsersSearchObject
}

class RolesTable extends Component<RolesTableProps, RolesTableState> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentPage: 1,
      headers: null,
      data: null,
      action: {
        editURL: "",
      },
      open: true,
      selectedId: "",
      selectedRecord: null,
      userDetails: {},
      isSuperAdmin: false
    };
    let { currentPage, headers, data, action } = props;
    this.setState(
      {
        currentPage: currentPage,
        headers: headers,
        data: data,
        action: action,
      },
      () => {
        this.renderTable();
      }
    );
  }

  componentDidMount(){
    this.props.setLoggedInUser();
  }

  componentDidUpdate(prevProps: any, prevState: any){
    if(prevProps.userDetails !== this.props.userDetails) {
      this.setState({
        userDetails: this.props.userDetails,
      isSuperAdmin:
        this.props.userDetails &&
        this.props.userDetails.authenticatedUser &&
        this.props.userDetails.authenticatedUser.isSuperAdmin},
        )  
    }

    if(prevProps.rolesChips !== this.props.rolesChips){
      if(this.props.rolesChips.length === 0){
        this.props.getRolesList({pageNumber: 1, getDefaultRoles: false})
        this.props.setPaginationToFirstPage();
      }
      this.searchBarText(this.props.rolesSearchData);
    }

    if(prevProps.rolesSearchData !== this.props.rolesSearchData){
    }
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    return {
      currentPage: nextProps.currentPage,
      headers: nextProps.headers,
      data: nextProps.data,
      action: nextProps.action,
    };
  }

  handleEditRole(redirectTo:any){
    if (this.props.isPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      this.props.history.push(redirectTo);
    }
  }

  handleSearch() {
		// const { searchText } = this.state;
		// if (this.props.searchTextChanged) {
		// 	this.props.searchTextChanged(searchText);
		// }
		

		// if(this.props.isRolesTab){
		// 	this.props.searchTextChanged({
		// 		rolesSearch: this.state.rolesSearch
		// 	});
		// } 
	}

  searchBarText(searchData: SearchDataObject){
    const { searchText, rolesSearch, usersSearch } = searchData;
    this.props.searchUserMgmt({
      selectedTab: "Roles",
      isSuperAdmin: this.state.isSuperAdmin,
      rolesSearch: this.props.rolesSearchData
    })
  }

  handleChipDelete = (chipText: string) => {
    //Remove chip from reducer
    this.props.removeRoleChip(chipText);
    //update Roles Search object and call this.props.searchTextChanged

    // If rolesChips.length === 0, call getRolesList and setPaginationToFirstPage

  }

  renderChips = () => {
    let chips:any = [];
			if(this.props.rolesChips) {
				this.props.rolesChips.forEach((chip: string) => chips.push(
					<Chip
						label={chip}
						onDelete={() => this.handleChipDelete(chip)}
					/>
				));
			}
			return chips;
  }

  render() {
    const { classes, currentPage, isSuperAdmin } = this.props;
    let defaultRoleTable: any;
    if (isSuperAdmin) {
      defaultRoleTable = this.renderDefaultTable();
    }
    let table = this.renderTable(currentPage);

    return (
      <>
        {isSuperAdmin && (
          <>
            <Grid className={classes.headingText}>Default Roles</Grid>
            {defaultRoleTable}
          </>
        )}
        <>
            <Grid container justify="space-between" alignItems="center" className={classes.customContainer}>
              <Grid item xs={6}>
               {isSuperAdmin && <Typography className={classes.headingTxt}>Custom Roles</Typography> }
              </Grid>
              <Grid item xs={6}>
                  <span className={classes.searchBar}>
                    Add Filters:
                    <MyPATSearchBar
                      isSelect={true}
                      // searchText={this.state.searchText}
                      isRolesTab={true}
                      isUsersTab={false}
                      searchTextChanged={(searchData: SearchDataObject) =>
                        this.searchBarText(searchData)
                      }
                    />
                  </span>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} className={classes.chipContainer}>
                {this.renderChips()}
              </Grid>
            </Grid>
          </>
       
        {table}
      </>
    );
  }

  renderTable = (currentPage?: any) => {
    const { classes } = this.props;
    let headersJSX = this.renderHeaders(this.state.headers, this.state.action);
    let dataJSX = this.renderData(
      currentPage,
      this.state.data,
      this.state.action
    );

    let table = (     
      <Paper className={classes.customPaper}>
        <Table classes={{ root: classes.table }} padding="checkbox">
          <TableHead classes={{ root: classes.tableHead }}>
            <TableRow>{headersJSX}</TableRow>
          </TableHead>
          <TableBody>{dataJSX}</TableBody>

          <TableBody />
        </Table>
      </Paper>
    );
    return table;
  };
  renderDefaultTable = () => {
    const { classes } = this.props;
    let headersJSX = this.renderHeaders(this.state.headers, this.state.action);
    let dataJSX = this.renderDefaultData(this.props.defaultRolesData);

    let table = (      
      <Paper className={classes.customPaper}>
        <Table classes={{ root: classes.table }} padding="checkbox">
          <TableHead classes={{ root: classes.tableHead }}>
            <TableRow>{headersJSX}</TableRow>
          </TableHead>
          <TableBody>{dataJSX}</TableBody>

          <TableBody />
        </Table>
      </Paper>
    );
    return table;
  };
  renderHeaders = (headers: any, action: any) => {
    // Return a list of TableCell Elements
    const { classes } = this.props;
    let headerCells =
      headers !== null &&
      headers.map((header: any, index: any) => {
        return (
          <TableCell
            key={index}
            classes={{ head: classes.textSM, root: classes.tableCell }}
            align="center"
          >
            {header}
          </TableCell>
        );
      });
    return headerCells;
  };

  closeDialog() {
    this.setState({
      selectedId: "",
    });
  }
  getPermissionsData(module: any) {
    if (this.state.selectedRecord !== null) {
      return (
        this.state.selectedRecord &&
        this.state.selectedRecord.permissions &&
        this.state.selectedRecord.permissions.filter(function(val: any) {
          if (val.module === module) {
            return val;
          }
        })
      );
    }
  }
  checkValueFormat(ele: any) {
    if(ele === "createOptional") {
      return "Create Optional"
    } else if(ele === "createMandatory") {
      return "Create Mandatory"
    } else {
      return ele
    }
  }
  handleViewPermission = (record: any) => {

    const { classes } = this.props;
    const { selectedRecord } = this.state;
    const edpIssuePermissionsData = this.getPermissionsData(MODULES.EDP_QUESTION_ISSUE_REPORT) || [];
    const edpCreationPermissionsData = this.getPermissionsData(MODULES.EDP_QUESTION_CREATE_REPORT) || [];
    return (
      <>
        <MyPATDialog
          dialogOpen={this.state.selectedId === record._id}
          dialogHasActions={true}
          dialogHeading="View Permissions"
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          isCustomBackground={false}
          isborderDialogAction={true}
          onDialogClose={() => {
            this.setState({
              selectedId: "",
            });
          }}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          customDialogActions={
            <>
              <Grid container justify="flex-end" alignItems="flex-end">
                {(
                  selectedRecord &&
                  selectedRecord.isDefault === false
                ) && (
                  <Link
                    to={`${this.state.action && this.state.action.editURL}${
                      record._id
                    }`}
                    className={[classes.fontSize_SM, classes.grey, classes.textDecorationNone].join(' ')}
                    >
                    <Button>Edit</Button>
                  </Link>
                )}
                {selectedRecord &&
                  (selectedRecord.isDefault || selectedRecord.isDefault === undefined) && (
                    <Button disabled>Edit</Button>
                  )}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.btnCreateGoal}
                  onClick={() => {
                    this.setState({
                      selectedId: "",
                    });
                  }}
                >
                  Okay
                </Button>
              </Grid>
            </>
          }
        >
          <Grid className={classes.permissionPlaceholderBorder}>
            <span>MyLibrary</span>
            <Grid container className={classes.widthMD}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span className={[classes.area200, 
                    classes.fontSize_SM, 
                    classes.fontWeight_MD , classes.black, classes.lineHeightMD].join(' ')}>Study Material :</span>
                  {this.getPermissionsData("studyMaterial") &&
                    this.getPermissionsData("studyMaterial")[0].access.map(
                      (ele: any) => {
                        return <><span className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM ,classes.grey].join(' ')}>{ele}</span>
                          <span className={classes.commaCode}>&#44;</span></>;
                      }
                    )}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">
                  <span className={[classes.area200, 
                    classes.fontSize_SM, 
                    classes.fontWeight_MD , classes.black, classes.lineHeightMD].join(' ')}>Template Settings :</span>
                  {this.getPermissionsData("rule") &&
                    this.getPermissionsData("rule")[0].access.map(
                      (ele: any) => {
                        return <><span className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM ,classes.grey].join(' ')}>{ele}</span>
                          <span className={classes.commaCode}>&#44;</span></>;
                      }
                    )}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">
                  <span className={[classes.area200, 
                    classes.fontSize_SM, 
                    classes.fontWeight_MD , classes.black, classes.lineHeightMD].join(' ')}>Questions :</span>
                  {this.getPermissionsData("question") &&
                    this.getPermissionsData("question")[0].access.map(
                      (ele: any) => {
                        return <><span className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM ,classes.grey].join(' ')}>{ele}</span>
                          <span className={classes.commaCode}>&#44;</span></>;
                      }
                    )}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span className={[classes.area200, 
                    classes.fontSize_SM, 
                    classes.fontWeight_MD , classes.black, classes.lineHeightMD].join(' ')}>Tag Settings :</span>
                  {this.getPermissionsData("tag") &&
                    this.getPermissionsData("tag")[0].access.map((ele: any) => {
                      return <><span className={[ 
                        classes.fontSize_SM, classes.textCapitalize,
                        classes.fontWeight_SM ,classes.grey].join(' ')}>{this.checkValueFormat(ele)}</span>
                        <span className={classes.commaCode}>&#44;</span></>;
                    })}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span className={[classes.area200, 
                    classes.fontSize_SM, 
                    classes.fontWeight_MD , classes.black, classes.lineHeightMD].join(' ')}>Tests :</span>
                  {this.getPermissionsData("test") &&
                    this.getPermissionsData("test")[0].access.map(
                      (ele: any) => {
                        return <><span className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM ,classes.grey].join(' ')}>{ele}</span>
                          <span className={classes.commaCode}>&#44;</span></>;
                      }
                    )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            {(this.getPermissionsData("goal") &&
              this.getPermissionsData("goal").length === 1) && (
                <Grid item xs={4} className={classes.marginTB}>
                  <Typography variant="body1" className={[ 
                    classes.fontSize_MD, 
                    classes.fontWeight_MD , classes.grey, classes.lineHeightMD].join(' ')}>Goal Management</Typography>

                  {this.getPermissionsData("goal") &&
                    this.getPermissionsData("goal")[0].access.map(
                      (ele: any) => {
                        return <Typography variant="body1" className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM , classes.grey].join(' ')}>{ele}</Typography>;
                      }
                    )}
                </Grid>
              )}
            {(!!edpCreationPermissionsData.length  ||
              !!edpIssuePermissionsData.length ) && (
                <Grid item xs={4} className={classes.marginTB}>
                  <Typography variant="body1" className={[
                    classes.fontSize_MD,
                    classes.fontWeight_MD, classes.grey, classes.lineHeightMD].join(' ')}>EDP Reports</Typography>
                {(edpCreationPermissionsData[0].access) && (
                  <FormGroup row>
                    <Typography variant="body1"
                      className={cx(
                        classes.fontSize_SM, classes.textCapitalize,
                        classes.fontWeight_SM, classes.grey
                      )}
                    >
                      Question Creation:&nbsp;
                    </Typography>
                    {(edpCreationPermissionsData[0].access || []).map((ele: any, index: number) => (
                      <Typography key={index} variant="body1"
                        className={cx(
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM, classes.black
                        )}
                      >
                        {ele}
                      </Typography>
                    ))}
                  </FormGroup>
                  )}
                {(edpIssuePermissionsData[0].access) && (
                  <FormGroup row>
                    <Typography variant="body1"
                      className={cx(
                        classes.fontSize_SM, classes.textCapitalize,
                        classes.fontWeight_SM, classes.grey
                      )}
                    >
                      Question Issues:&nbsp;
                    </Typography>
                    {(edpIssuePermissionsData[0].access || []).map((ele: any, index: number) => (
                      <Typography key={index} variant="body1"
                        className={cx(
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM, classes.black
                        )}
                      >
                        {ele}
                      </Typography>
                    ))}
                  </FormGroup>
                )}
                </Grid>
              )}
              {(this.getPermissionsData("user") &&
              this.getPermissionsData("user").length === 1) && (
                <Grid item xs={4} className={classes.marginTB}>
                  <Typography variant="body1" className={[ 
                    classes.fontSize_MD, 
                    classes.fontWeight_MD , classes.grey, classes.lineHeightMD].join(' ')}>User Management</Typography>

                  {this.getPermissionsData("user") &&
                    this.getPermissionsData("user")[0].access.map(
                      (ele: any) => {
                        return <Typography variant="body1" className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM , classes.grey].join(' ')}>{ele}</Typography>;
                      }
                    )}
                </Grid>
              )}
            {this.getPermissionsData("course") &&
              this.getPermissionsData("course").length === 1 && (
                <Grid item xs={4} className={classes.marginTB}>
                  <Typography variant="body1" className={[ 
                    classes.fontSize_MD, 
                    classes.fontWeight_MD , classes.grey, classes.lineHeightMD].join(' ')}>Course Management</Typography>
                  {this.getPermissionsData("course") &&
                    this.getPermissionsData("course")[0].access.map(
                      (ele: any) => {
                        return <Typography variant="body1" className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM , classes.grey].join(' ')}>{ele}</Typography>;
                      }
                    )}{" "}
                </Grid>
              )}
            {this.getPermissionsData("share") &&
              this.getPermissionsData("share").length === 1 && (
                <Grid item xs={4} className={classes.marginTB}>
                  <Typography variant="body1" className={[ 
                    classes.fontSize_MD, 
                    classes.fontWeight_MD , classes.grey, classes.lineHeightMD].join(' ')}>Share Content</Typography>
                  {this.getPermissionsData("share") &&
                    this.getPermissionsData("share")[0].access.map(
                      (ele: any) => {
                        return <Typography variant="body1" className={[ 
                          classes.fontSize_SM, classes.textCapitalize,
                          classes.fontWeight_SM , classes.grey].join(' ')}>{ele}</Typography>;
                      }
                    )}{" "}
                </Grid>
              )}
          </Grid>
        </MyPATDialog>
      </>
    );
  };
  renderDefaultData(data: any) {
    const { classes } = this.props;
    let dataRows =     
      data && data.length !== 0 && data.map((record: any, index: any) => {
        return (
          <TableRow key={record._id} classes={{ root: classes.tableRow }}>
            {this.handleViewPermission(record)}

            <TableCell
              key={record._id}
              classes={{ root: classes.tableCell }}
              component="th"
              scope="row"
              align="center"
            >
              {index + 1}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {"All Clients"}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.name}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              <Grid
                className={classes.customLink}
                onClick={() => {
                  this.setState({
                    selectedId: record._id,
                    selectedRecord: record,
                  });
                }}
              >
                View
              </Grid>
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              <span className="opeacity50">Edit</span>  
            </TableCell>
          </TableRow>
        );
      });
    return dataRows;
  };
  
  renderData = (currentPage: any, data: any, action: any) => {
    // Return List of TableRows with TableCells each
    const { classes, isSuperAdmin } = this.props;
    const pageNumber = (currentPage - 1) * 10;
    let dataRows =
      data &&  data.length !== 0 && data.map((record: any, index: any) => {
        return (
          <TableRow key={record._id} classes={{ root: classes.tableRow }}>
            {this.handleViewPermission(record)}

            <TableCell
              key={record._id}
              classes={{ root: classes.tableCell }}
              component="th"
              scope="row"
              align="center"
            >
              {pageNumber + index + 1}
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.client.name}
              {record.client && record.client.name && record.client.name.length > 20 &&
            <Grid className="tooltip">
              {record.client.name}
            </Grid>
            }
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.role}
              {record.role && record.role.length > 20 &&
            <Grid className="tooltip">
              {record.role}
            </Grid>
            }
            </TableCell>
            {!isSuperAdmin && <TableCell classes={{ root: classes.tableCell }} align="center">
              {record.isDefault ? 
              <Typography className={[classes.roleTag, classes.bgblue].join(' ')}>Default Role</Typography> : 
              <Typography className={[classes.roleTag, classes.bgPurple].join(' ')}>Custom Role</Typography>
              }
            </TableCell>}
            <TableCell classes={{ root: classes.tableCell }} align="center">
              <Grid
                className={classes.customLink}
                onClick={() => {
                  this.setState({
                    selectedId: record._id,
                    selectedRecord: record,
                  });
                }}
              >
                View
              </Grid>
            </TableCell>
            <TableCell classes={{ root: classes.tableCell }} align="center">
              {!record.isDefault && (
                <Grid
                  // to={`${action.editURL}${record._id}`}
                  style={{ color: '#1D7DEA', cursor: 'pointer' }}
                  onClick={() => this.handleEditRole(`${action.editURL}${record._id}`)}
                >
                  Edit
                </Grid>
              )}
              {record.isDefault && <span className="opeacity50">Edit</span>}
            </TableCell>
          </TableRow>
        );
      });
    return dataRows;
  };
}

const mapStateToProps = (state: any) => ({
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays,
  defaultRolesData: state.clientManagement.rolesManagement.defaultRolesData,
  rolesChips: state.clientManagement.rolesManagement.rolesChips,
  rolesSearchData: state.clientManagement.rolesManagement.rolesSearchData
});

const mapDispatchToProps = {
  toggleLicenseExpiredDialog,
  setLoggedInUser,
  searchUserMgmt,
  getRolesList,
  setPaginationToFirstPage,
  removeRoleChip
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(RolesTable)));
